import * as Api from '@ViewModels';
import { css } from 'aphrodite';
import * as React from 'react';
import { useFormContext } from 'react-hook-form';
import { Link } from 'react-router-dom';
import { useEnsureEventVolunteerCompanionQuery } from '../../../../../../queries/Volunteer';
import { Button } from '../../../../../components-v2/Button';
import { Checkbox } from '../../../../../components-v2/Checkbox';
import { Field } from '../../../../../components-v2/Field';
import { Label } from '../../../../../components-v2/Label';
import { ROUTES } from '../../../../../constants/routes';
import { EventRegistrationFormData } from '../../utils';
import { styleSheet } from './styles';

interface IProps {
	surveyId?: string;
	persistedVolunteerEnabled?: boolean;
	impersonationContext?: Api.IImpersonationContext;
}

export const VolunteersTab: React.FC<IProps> = ({ surveyId, persistedVolunteerEnabled, impersonationContext }) => {
	const { watch, setValue } = useFormContext<EventRegistrationFormData>();
	const enabled = watch('volunteerSettings.enabled');
	const {
		data: companion,
		isLoading: isCompanionLoading,
		isError: companionFailed,
	} = useEnsureEventVolunteerCompanionQuery({
		eventSurveyId: surveyId,
		enabled: !!enabled && !!persistedVolunteerEnabled,
		impersonationContext,
	});

	return (
		<div className={css(styleSheet.root)}>
			<Field orientation='horizontal'>
				<Checkbox
					checked={enabled}
					onCheckedChange={next => setValue('volunteerSettings.enabled', next === true, { shouldDirty: true })}
				/>
				<Label>Enable volunteers for this event</Label>
			</Field>
			{enabled ? (
				<>
					{companion ? (
						<div className={css(styleSheet.activityLink)}>
							<div className={css(styleSheet.activityLinkText)}>
								<span className={css(styleSheet.activityLinkTitle)}>Volunteer activity</span>
								<span className={css(styleSheet.activityLinkDescription)}>
									Shifts, the signup survey and its link, the roster and the volunteer tag all live on this
									event&rsquo;s volunteer activity. Set the tag on the activity&rsquo;s Details tab.
								</span>
							</div>
							<Button variant='link' size='sm' asChild styles={[styleSheet.activityLinkAction]}>
								<Link to={`${ROUTES.volunteers.home}/${companion.id}`}>Open volunteer activity</Link>
							</Button>
						</div>
					) : isCompanionLoading ? (
						<div className={css(styleSheet.notice)}>Setting up this event&rsquo;s volunteer activity&hellip;</div>
					) : companionFailed ? (
						<div className={css(styleSheet.notice)}>
							This event&rsquo;s volunteer activity couldn&rsquo;t be loaded. Reload the page to try again.
						</div>
					) : (
						<div className={css(styleSheet.notice)}>
							Save the event with volunteers enabled to create its volunteer activity &mdash; shifts, the signup survey
							and the volunteer tag are set up there.
						</div>
					)}
				</>
			) : null}
		</div>
	);
};
